import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from 'src/app/core/apiConfig';
import { AddOnsData } from 'src/app/core/data';
import { AddonsRequestDTO, BaseResponse } from 'src/app/core/models';
import { UtilityService } from '../..';
import { BundlesCongfigurationdata } from 'src/app/core/data/admin/bundles-configuration-data';
import { BundlesConfigurationDto } from 'src/app/core/models/admin/bundle-conf';

@Injectable({
    providedIn: "root",
})
export class BundlesService extends BundlesCongfigurationdata {
    constructor(private utilityService: UtilityService) {
        super();
    }

    getBundlesConfiguration(id: string=null): Observable<BaseResponse<BundlesConfigurationDto[]>> {
       return this.utilityService.postPut<BundlesConfigurationDto[]>(ApiConfig.admin.getBundlesConfiguration,null,id)
    }
    addBundlesConfiguration(data: BundlesConfigurationDto,id:any): Observable<BaseResponse<BundlesConfigurationDto>> {
        return this.utilityService.postPut<BundlesConfigurationDto>(ApiConfig.admin.addBundlesConfiguration,data,id)
    }
    deleteBundlesConfiguration(id?: string): Observable<BaseResponse<BundlesConfigurationDto>> {
        return this.utilityService.postPut<BundlesConfigurationDto>(ApiConfig.admin.deleteBundlesConfiguration,null,id)
    }

}
